<template>
  <div>
    <Chart :cdata="cdata" :tabname="tabnames" :edata="edata"/>
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  data () {
    return {
      cdata: [],
      tabnames:[],
      edata:[]
    }
  },
  components: {
    Chart,
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>